import React, { useRef, useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
import PhoneIcon from 'components/icons/Phone';
import ArrowRightIcon from 'components/icons/ArrowRight';
import Link from 'components/shared/link';
import styles from './styles.module.scss';
import { useMedia } from 'react-use';

const MediaWithTextListItem = ({
  title = null,
  description = null,
  isDarkTheme = false,
  image = null,
  buttonLink = null,
  buttonLabel = null,
  secondaryButtonLink = null,
  secondaryButtonLabel = null,
  reverse = false,
}) => {
  const mediaContainerRef = useRef(null);

  const [isClient, setIsClient] = useState(false);
  const isMobile = useMedia('(max-width: 767px)', false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const appendImageToCard = useCallback((cardId) => {
    const imageDiv = document.getElementById(`img-${cardId}`);
    if (imageDiv && mediaContainerRef.current) {
      mediaContainerRef.current.innerHTML = '';
      mediaContainerRef.current.appendChild(imageDiv);
    }
  }, []);

  // Handle image appending for this specific card
  useEffect(() => {
    if (image?.id) {
      appendImageToCard(image.id);
    }
  }, [image, appendImageToCard]);

  const isPhone = useMemo(() => buttonLink?.includes('tel:'), [buttonLink]);
  const isSecondarryButtonPhone = useMemo(
    () => secondaryButtonLink?.includes('tel:'),
    [secondaryButtonLink]
  );

  return (
    <div
      className={cn(styles.item, { [styles.reverse]: reverse, [styles.themeDark]: isDarkTheme })}
    >
      {isClient && isMobile && title && (
        <Heading className={styles.title} tag="h3" size="lg">
          {title}
        </Heading>
      )}
      <div className={styles.mediaContainer}>
        <div className={styles.image} ref={mediaContainerRef} />
      </div>
      <div className={styles.content}>
        {title && (!isClient || !isMobile) && (
          <Heading className={styles.title} tag="h3" size="lg">
            {title}
          </Heading>
        )}
        {description && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        )}
        {buttonLabel && buttonLink && (
          <div className={styles.btnBox}>
            {/* {buttonHint && <p className={styles.btnHint}>{buttonHint}</p>} */}
            <Button
              theme="accent-primary"
              to={buttonLink}
              className={cn(styles.btn, { [styles.btnPhone]: isPhone })}
              size="md"
            >
              {isPhone && <PhoneIcon />}
              {buttonLabel}
              {!isPhone && <ArrowRightIcon />}
            </Button>
          </div>
        )}
        {secondaryButtonLink && secondaryButtonLabel && (
          <div className={styles.secondaryBtnBox}>
            <Link to={secondaryButtonLink} className={styles.secondaryBtn}>
              {isSecondarryButtonPhone && <PhoneIcon />}
              <span>{secondaryButtonLabel}</span>
              {!isSecondarryButtonPhone && <ArrowRightIcon />}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaWithTextListItem;

MediaWithTextListItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isDarkTheme: PropTypes.bool,
  image: PropTypes.shape({
    id: PropTypes.number,
  }),
  buttonLink: PropTypes.string,
  buttonLabel: PropTypes.string,
  secondaryButtonLink: PropTypes.string,
  secondaryButtonLabel: PropTypes.string,
  reverse: PropTypes.oneOf([true, false, 1]),
};
